module.exports = __webpack_public_path__ + "img/friend.f7f12c85.png";